import { render } from "./LogoutView.vue?vue&type=template&id=473a313c&scoped=true"
import script from "./LogoutView.vue?vue&type=script&lang=js"
export * from "./LogoutView.vue?vue&type=script&lang=js"

import "./LogoutView.vue?vue&type=style&index=0&id=473a313c&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473a313c"]])

export default __exports__